import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Switch, Route } from 'react-router-dom';
import clsx from 'clsx';
import { Card, CardContent } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import "../Styles/react-datepicker.css";
import Moment from 'moment'
import Loader from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import DemoForm from './DemoForm';
import Images from '../Theme/Images';
import { ReactSVG } from 'react-svg';
import momentTimezone from 'moment-timezone';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SchedulerBg from './SchedulerBg';
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.dullGray,
        color: theme.palette.white,
        boxShadow: theme.shadows[1],
        fontSize: '13px',
    },
    arrow: {
        color: theme.palette.dullGray,
    }
}))(Tooltip);
const fields = [
    {
        name: 'name',
        label: 'Name*',
        required: true,
    },
    {
        name: 'phone',
        label: 'Phone Number*',
        required: true,
    }
]
@inject('commonStore') @observer
@observer
class DurationForm extends Component {
    state = {
        duration: 'sixtyMin',
    }

    componentDidMount() {
        this.props.commonStore.showFreeSlots(Moment(new Date()).format('MMMM'), momentTimezone.tz.guess())
    }

    setDuration = (v) => {
        this.setState({ duration: v })
        this.props.history.push('/selectDate')
        this.props.history.push({
            pathname: `/selectDate`,
            state: { duration: v }
        })
    }

    render() {
        const { duration, } = this.state;
        return (
            <div className='durationForm flexGrow' style={{margin: '1vw'}}>
                <div className='rowFlex'>
                    <div className={clsx({ 'duration-cont subHeading1': true, 'selectedDuration-cont': duration === 'sixtyMin' })} onClick={(e) => this.setDuration('sixtyMin')}>
                        60 Minute Meeting
                    </div>
                    <div className={clsx({ 'duration-cont subHeading1': true, 'selectedDuration-cont': duration === 'thirtyMin' })} onClick={(e) => this.setDuration('thirtyMin')}>
                        30 Minute Meeting
                    </div>
                </div>
            </div>

        )
    }
}
DurationForm.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(DurationForm);
